import {connect} from 'react-redux'
import ReportPanel from '../components/report-panel'
import * as reportActions from '../store/report/actions'
import * as decisionTreeActions from '../store/decision-tree/actions'

export default connect((state) => {
  return {
    report: state.report,
    decisionTree: state.decisionTree,
  }
}, {...reportActions, ...decisionTreeActions})(ReportPanel)



// WEBPACK FOOTER //
// ./src/containers/report-panel-container.js